import type { ActivityEntry, Holding, Index, NewsItem, StockWithSeries } from '@tradekaro/shared';

const PSX_STOCKS = [
  { sym: 'ENGROH', name: 'Engro Holdings', sector: 'Conglomerate', price: 318.42, change: 2.14 },
  { sym: 'OGDC', name: 'Oil & Gas Devco', sector: 'Energy', price: 142.78, change: -0.82 },
  { sym: 'LUCK', name: 'Lucky Cement', sector: 'Materials', price: 824.1, change: 1.42 },
  { sym: 'HBL', name: 'Habib Bank Ltd', sector: 'Banking', price: 118.65, change: 0.34 },
  { sym: 'MEBL', name: 'Meezan Bank', sector: 'Banking', price: 226.9, change: 1.78 },
  { sym: 'PSO', name: 'Pakistan State Oil', sector: 'Energy', price: 196.05, change: -1.12 },
  { sym: 'NESTLE', name: 'Nestlé Pakistan', sector: 'Consumer', price: 6840.0, change: 0.62 },
  { sym: 'FFBL', name: 'Fauji Fert Bin', sector: 'Fertilizer', price: 38.24, change: 3.41 },
  { sym: 'TRG', name: 'TRG Pakistan', sector: 'Tech', price: 62.18, change: 4.22 },
  { sym: 'SYS', name: 'Systems Limited', sector: 'Tech', price: 412.55, change: 1.04 },
  { sym: 'UBL', name: 'United Bank Ltd', sector: 'Banking', price: 234.8, change: -0.41 },
  { sym: 'PPL', name: 'Pakistan Petro', sector: 'Energy', price: 168.3, change: 0.91 },
];

export function genSeries(end: number, changePct: number, n = 40, vol = 0.6): number[] {
  const start = end / (1 + changePct / 100);
  const arr: number[] = [];
  let v = start;
  for (let i = 0; i < n; i++) {
    const t = i / (n - 1);
    const target = start + (end - start) * t;
    const noise = (Math.random() - 0.5) * (Math.abs(end - start) * vol + end * 0.002);
    v = target + noise;
    arr.push(v);
  }
  arr[arr.length - 1] = end;
  return arr;
}

export const STOCKS_WITH_SERIES: StockWithSeries[] = PSX_STOCKS.map((s) => ({
  ...s,
  last: s.price,
  series: genSeries(s.price, s.change),
}));

function genPortfolioSeries(endValue: number, changePct: number, n = 78) {
  return genSeries(endValue, changePct, n, 0.4);
}

export const PORTFOLIO = {
  totalValue: 1842650.4,
  invested: 1612400.0,
  dayChange: 18420.55,
  dayChangePct: 1.01,
  totalGain: 230250.4,
  totalGainPct: 14.28,
  cash: 84210.0,
  series: genPortfolioSeries(1842650.4, 1.01),
};

export const HOLDINGS: Holding[] = [
  { sym: 'ENGROH', qty: 250, avg: 281.4, color: 'oklch(0.55 0.13 155)' },
  { sym: 'MEBL', qty: 800, avg: 198.2, color: 'oklch(0.62 0.12 220)' },
  { sym: 'LUCK', qty: 120, avg: 762.8, color: 'oklch(0.68 0.13 75)' },
  { sym: 'SYS', qty: 410, avg: 380.0, color: 'oklch(0.58 0.14 310)' },
  { sym: 'HBL', qty: 1200, avg: 112.5, color: 'oklch(0.6 0.12 30)' },
];

export const INDICES: Index[] = [
  { name: 'KSE-100', value: 78420.18, change: 0.84, series: genSeries(78420.18, 0.84) },
  { name: 'KSE-30', value: 24108.42, change: 1.12, series: genSeries(24108.42, 1.12) },
  { name: 'KMI-30', value: 128340.55, change: -0.31, series: genSeries(128340.55, -0.31) },
  { name: 'ALLSHR', value: 49210.92, change: 0.42, series: genSeries(49210.92, 0.42) },
];

export const NEWS: NewsItem[] = [
  {
    tag: 'MARKET',
    time: '12 min',
    title: 'KSE-100 crosses 78,400 led by cement & tech rally',
    source: 'Business Recorder',
  },
  {
    tag: 'EARNINGS',
    time: '47 min',
    title: 'Engro Holdings posts record quarterly profit, beats estimates by 8%',
    source: 'Dawn',
  },
  {
    tag: 'POLICY',
    time: '2 hr',
    title: 'SBP holds policy rate at 12%; bond yields ease across curve',
    source: 'Reuters',
  },
  {
    tag: 'SECTOR',
    time: '3 hr',
    title: 'Tech stocks lead gainers as TRG, Systems extend monthly streak',
    source: 'Mettis Global',
  },
];

export const ACTIVITY: ActivityEntry[] = [
  { type: 'BUY', sym: 'MEBL', qty: 100, price: 226.2, time: '10:42' },
  { type: 'DEPOSIT', amount: 50000, time: '09:15' },
  { type: 'SELL', sym: 'OGDC', qty: 200, price: 144.05, time: 'Yesterday' },
  { type: 'DIVIDEND', sym: 'ENGROH', amount: 1875, time: 'Apr 24' },
];
